import { createContext, useContext, useMemo, useState } from 'react';

const ClinicContext = createContext();

export const useClinic = () => {
  return useContext(ClinicContext);
};

export const ClinicProvider = ({ children }) => {
  const [selectedClinic, setSelectedClinic] = useState(null);

  const value = useMemo(() => ({ selectedClinic, setSelectedClinic }), [selectedClinic]);

  return (
    <ClinicContext.Provider value={value}>
      {children}
    </ClinicContext.Provider>
  );
};
